import React, { useRef } from 'react';
import styles from '../../../styles/pages/user/qcagentdashboard/qc-support.module.scss'
import EditorDashboardWrapper from '../../../layout/wrapper/EditorDashboardWrapper';
import { Box, List, ListItem, Select, MenuItem, Button, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Typography, Dialog, Grid, TextField } from '@mui/material';
import key_icon from '../../../public/assets/images/lock_icon.svg';
import PerfectScrollbar from "react-perfect-scrollbar"
import view_icon from '../../../public/assets/images/eye_icon.svg'
import LeftArrow from '../../../ui/Icons/LeftArrow';
import RightArrow from '../../../ui/Icons/RightArrow';
import { useState } from 'react';
import CrossIcon from '../../../ui/Icons/CrossIcon';
import UploadPin from '../../../ui/Icons/UploadPin';
import { useNavigate } from 'react-router';
import headPhone from '../../../public/assets/images/headphone.svg';
import { Link } from 'react-router-dom';
import QcDashboardWrapper from '../../../layout/wrapper/QcDashboradWrapper';





const SelectItem = [
    {
        name: "Ticket Status",
    },
    {
        name: "Option1",
    },
    {
        name: "Option2",
    }
]

const TicketSelectItem = [
    {
        name: "Option1",
    },
    {
        name: "Option2",
    }
]


const tableHead = [
    {
        name: "Ticket ID"
    },
    {
        name: "Priority"
    },
    {
        name: "Subject"
    },
    {
        name: "Message"
    },
    {
        name: "Creation Date"
    },
    {
        name: "Ticket Status"
    },
    {
        name: "View"
    }
]

const tableBody = [
    {
        id: "#SR5264",
        priority: "low",
        subject: "I Want To Reset My Password",
        message: "Hi there, how are you doing? I was trying to reest my password but it kept showing and I am not su...",
        date: <>January 16, 2023 <br />at 07:53 AM UTC </>,
        statusQuery: false,
    },
    {
        id: "#SR3214",
        priority: "high",
        subject: "When will I be paid?",
        message: "I am curious on when I’ll be paid? Could you please let me know? Thanks in advance!",
        date: <>January 14, 2023 <br />at 10:22 PM UTC </>,
        statusQuery: true,
    },
    {
        id: "#SR3214",
        priority: "critical",
        subject: "When will I be paid?",
        message: "I am curious on when I’ll be paid? Could you please let me know? Thanks in advance!",
        date: <>January 14, 2023 <br />at 10:22 PM UTC </>,
        statusQuery: true,
    },
    {
        id: "#SR3214",
        priority: "medium",
        subject: "When will I be paid?",
        message: "I am curious on when I’ll be paid? Could you please let me know? Thanks in advance!",
        date: <>January 14, 2023 <br />at 10:22 PM UTC </>,
        statusQuery: true,
    },


]



const tableHeadArchieve = [
    {
        name: "Ticket ID"
    },
    {
        name: "Subject"
    },
    {
        name: "Message"
    },
    {
        name: "Creation Date"
    },
    {
        name: "Resolved On"
    },
    {
        name: "View"
    }
]

const tableBodyArchieve = [
    {
        id: "#SR5264",
        subject: "I Want To Reset My Password",
        message: "Hi there, how are you doing? I was trying to reest my password but it kept showing and I am not su...",
        date: <>January 16, 2023 <br /> at 07:53 AM UTC</>,
        resolveDate: <>January 16, 2023 <br /> at 07:53 AM UTC</>,
    },

    {
        id: "#SR3214",
        subject: "When will I be paid?",
        message: "I am curious on when I’ll be paid? Could you please let me know? Thanks in advance!",
        date: <>January 14, 2023 <br /> at 10:22 PM UTC</>,
        resolveDate: <>January 16, 2023 <br /> at 07:53 AM UTC</>,
    },

    {
        id: "#SR3214",
        subject: "When will I be paid?",
        message: "I am curious on when I’ll be paid? Could you please let me know? Thanks in advance!",
        date: <>January 14, 2023 <br /> at 10:22 PM UTC</>,
        resolveDate: <>January 16, 2023 <br /> at 07:53 AM UTC</>,
    },

    {
        id: "#SR3214",
        subject: "When will I be paid?",
        message: "I am curious on when I’ll be paid? Could you please let me know? Thanks in advance!",
        date: <>January 14, 2023 <br /> at 10:22 PM UTC</>,
        resolveDate: <>January 16, 2023 <br /> at 07:53 AM UTC</>,
    },




]




function QcSupport() {
    const [age, setAge] = React.useState('0');
    const handleChange2 = (event) => {
        setAge(event.target.value);
    };


    const [age2, setAge2] = React.useState();
    const handleChange3 = (event) => {
        setAge2(event.target.value);
    };

    const [Archive, ArchiveUpdate] = useState(false);

    const handleClicked = () => {
        ArchiveUpdate(!Archive);
    }

    const [open, setOpen] = React.useState(false);

    const ticketClickOpen = () => {
        setOpen(true);
    };

    const ticketClose = (value) => {
        setOpen(false);
    };

    const fileInput = useRef(null)

    const handleClick = () => {
        fileInput.current.children[0].children[0].click()
    }



    const [open3, setOpen3] = React.useState(false);

    const ticketClickOpen3 = () => {
        setOpen3(true);
    };

    const ticketClose3 = (value) => {
        setOpen3(false);
    };

    const [ticketSuccess, ticketSuccessdUpdate] = React.useState(false);
    const navigate = useNavigate();

    const ticketCreated = (e) => {
        setOpen(false);
        ticketSuccessdUpdate(true);
        setTimeout(() => {
            navigate('/qcagent-dashboard/qc-support/ticket');
        }, "2000");
    }

    const [ticketShow, ticketEmpty] = React.useState(true);


    return (
        <>
            <QcDashboardWrapper>
                {
                    ticketShow ?
                        <>
                            {
                                ticketSuccess ?
                                    <Box className={styles.ticket_creation_wrapper}>
                                        <Typography variant='caption' className={styles.ticket_create_span}>Ticket Created Successfully</Typography>
                                    </Box>
                                    :
                                    ""
                            }

                            <Box className={styles.message_status_wrapper}>
                                <Box className={styles.message_status_topwrp}>
                                    <Box className={styles.message_status_topwrp_lft}>
                                        <List>
                                            <ListItem>
                                                <Box className={styles.status_messages_select}>
                                                    <Select
                                                        onChange={handleChange2}
                                                        value={age}
                                                    >
                                                        {
                                                            SelectItem.map((item, index) => (
                                                                <MenuItem value={index}>{item?.name}</MenuItem>
                                                            ))
                                                        }

                                                    </Select>
                                                </Box>
                                            </ListItem>

                                            <ListItem>
                                                <Box className={styles.creation_date}>
                                                    <Button>
                                                        Creation Date
                                                        <i><img src={key_icon} alt='' /></i>
                                                    </Button>
                                                </Box>
                                            </ListItem>

                                            <ListItem>
                                                <Button className={Archive ? `${styles.archievr_btns} ${styles.active}` : `${styles.archievr_btns}`} onClick={handleClicked}>Archive</Button>
                                            </ListItem>
                                        </List>
                                    </Box>

                                    <Box className={styles.message_status_topwrp_rtt}>
                                        <Button className={styles.ticket_btn_black} onClick={ticketClickOpen}>New Ticket</Button>
                                    </Box>
                                </Box>


                                <Box className={styles.message_status_btmwrp}>
                                    {
                                        Archive ?
                                            <PerfectScrollbar className={styles.tableScroll}>
                                                <TableContainer>
                                                    <Table aria-label="customized table" className={styles.new_table_customised}>
                                                        <TableHead>
                                                            <TableRow>

                                                                {
                                                                    tableHeadArchieve.map((item, index) => (
                                                                        <TableCell component="th">
                                                                            {item?.name}
                                                                        </TableCell>
                                                                    ))
                                                                }

                                                            </TableRow>
                                                        </TableHead>

                                                        <TableBody>
                                                            {
                                                                tableBodyArchieve.map((item, index) => (
                                                                    <TableRow>
                                                                        <TableCell component="td" scope="row" className={styles.ticket_id_table}>
                                                                            <Box className={styles.table_id_captns}>
                                                                                <Link to="/">{item?.id}</Link>

                                                                                <Typography variant='caption' className={styles.tooltips_spn}>Open Video Page</Typography>
                                                                            </Box>
                                                                        </TableCell>


                                                                        <TableCell component="td" scope="row" className={styles.subject_table}>
                                                                            {item?.subject}
                                                                        </TableCell>

                                                                        <TableCell component="td" scope="row" className={styles.messages_table}>
                                                                            {item?.message}
                                                                        </TableCell>

                                                                        <TableCell component="td" scope="row" className={styles.creation_date_table}>
                                                                            {item?.date}
                                                                        </TableCell>

                                                                        <TableCell component="td" scope="row" className={styles.resolve_table_date}>
                                                                            {item?.resolveDate}
                                                                        </TableCell>

                                                                        <TableCell component="td" scope="row" className={styles.view_sec_table}>
                                                                            <Box className={styles.eye_icon_tooltip}>
                                                                                <Button className={styles.eye_icon_sec}><img src={view_icon} alt='' /></Button>
                                                                                <Typography variant='caption' className={styles.tooltips_spn2}>Open Message</Typography>
                                                                            </Box>
                                                                        </TableCell>

                                                                    </TableRow>
                                                                ))
                                                            }
                                                        </TableBody>

                                                    </Table>
                                                </TableContainer>
                                            </PerfectScrollbar>
                                            :
                                            <PerfectScrollbar className={styles.tableScroll}>
                                                <TableContainer>
                                                    <Table aria-label="customized table">
                                                        <TableHead>
                                                            <TableRow>

                                                                {
                                                                    tableHead.map((item, index) => (
                                                                        <TableCell component="th">
                                                                            {item?.name}
                                                                        </TableCell>
                                                                    ))
                                                                }

                                                            </TableRow>
                                                        </TableHead>

                                                        <TableBody>
                                                            {
                                                                tableBody.map((item, index) => (
                                                                    <TableRow>
                                                                        <TableCell component="td" scope="row" className={styles.ticket_id_table}>
                                                                            <Box className={styles.table_id_captns}>
                                                                                <Link to="/">{item?.id}</Link>

                                                                                <Typography variant='caption' className={styles.tooltips_spn}>Open Video Page</Typography>
                                                                            </Box>
                                                                        </TableCell>

                                                                        <TableCell component="td" scope="row" className={styles.proiority_table}>
                                                                            <Typography variant='caption' className={item?.priority === "low" ? `${styles.low_priority} ${styles.cmn_structure_prority}` : item?.priority === "high" ? `${styles.high_priority} ${styles.cmn_structure_prority}` : item?.priority === "critical" ? `${styles.crtical_priority} ${styles.cmn_structure_prority}` : `${styles.medium_priority} ${styles.cmn_structure_prority}`}>
                                                                                {
                                                                                    item?.priority === "low" ?
                                                                                        "Low"
                                                                                        :
                                                                                        item?.priority === "high" ?
                                                                                            "High"
                                                                                            :
                                                                                            item?.priority === "critical" ?
                                                                                                "Critical"
                                                                                                :
                                                                                                "Medium"
                                                                                }
                                                                            </Typography>
                                                                        </TableCell>

                                                                        <TableCell component="td" scope="row" className={styles.subject_table}>
                                                                            {item?.subject}
                                                                        </TableCell>

                                                                        <TableCell component="td" scope="row" className={styles.messages_table}>
                                                                            {item?.message}
                                                                        </TableCell>

                                                                        <TableCell component="td" scope="row" className={styles.creation_date_table}>
                                                                            {item?.date}
                                                                        </TableCell>

                                                                        <TableCell component="td" scope="row" className={styles.status_table}>
                                                                            {
                                                                                item?.statusQuery ?
                                                                                    <Typography variant='caption' className={`${styles.quer_sec_btns} ${styles.resolved}`}>Resolved</Typography>
                                                                                    :
                                                                                    <Button className={styles.quer_sec_btns}>Need your reply</Button>
                                                                            }
                                                                        </TableCell>

                                                                        <TableCell component="td" scope="row" className={styles.view_sec_table}>
                                                                            <Box className={styles.eye_icon_tooltip}>
                                                                                <Button className={styles.eye_icon_sec}><img src={view_icon} alt='' /></Button>
                                                                                <Typography variant='caption' className={styles.tooltips_spn2}>Open Message</Typography>
                                                                            </Box>
                                                                        </TableCell>

                                                                    </TableRow>
                                                                ))
                                                            }
                                                        </TableBody>
                                                    </Table>
                                                </TableContainer>
                                            </PerfectScrollbar>
                                    }

                                </Box>


                                <Box className={styles.nextprev_btn}>
                                    <List>
                                        <ListItem>
                                            <Button className={`${styles.prev_btn} ${styles.cmn_pagination_btn}`}>
                                                <Typography variant='caption'><i><LeftArrow /></i> Prev</Typography>
                                            </Button>
                                        </ListItem>

                                        <ListItem>
                                            <Button className={`${styles.nxt_btn} ${styles.cmn_pagination_btn}`}>
                                                <Typography variant='caption'><i><RightArrow /></i> Next</Typography>
                                            </Button>
                                        </ListItem>
                                    </List>
                                </Box>

                            </Box>
                        </>
                        :
                        <Box className={styles.noticket_demo_outers}>
                            <i className={styles.ticket_icon_notify}><img src={headPhone} alt='' /></i>
                            <Typography variant='body1'>You don’t have any support tickets at the moment.</Typography>
                            <Button className={styles.ticket_collect_btns} onClick={ticketClickOpen3}>New Ticket</Button>
                        </Box>
                }

            </QcDashboardWrapper>



            <Dialog onClose={ticketClose} open={open} className={styles.dialog_coupon_modals}>
                <Box className={styles.ticket_support_modal}>
                    <Box className={styles.ticket_support_modal_top}>
                        <Typography variant='caption' className={styles.ticket_coupn_sec}>Create a new support ticket</Typography>

                        <Typography variant='caption' className={styles.ticket_id_sec}><strong>Ticket ID:</strong> #SR5264</Typography>
                        <Button className={styles.cross_icons} onClick={ticketClose}><CrossIcon /></Button>
                    </Box>


                    <Box className={styles.ticket_support_modal_btms}>
                        <Grid container spacing={2} className={styles.ticket_support_modal_btms_row}>
                            <Grid item lg={4.78} xs={12}>
                                <Box className={styles.ticket_form_modal}>
                                    <Typography variant='h5' className={styles.modal_h5}>Priority</Typography>
                                    <Box className={`${styles.status_messages_inputfrm} ${styles.selectbox}`}>
                                        <Select
                                            onChange={handleChange3}
                                            value={age2}
                                        >
                                            {
                                                TicketSelectItem.map((item, index) => (
                                                    <MenuItem value={index}>{item?.name}</MenuItem>
                                                ))
                                            }

                                        </Select>
                                    </Box>
                                </Box>
                            </Grid>

                            <Grid item lg={12} xs={12}>
                                <Box className={styles.ticket_form_modal}>
                                    <Typography variant='h5' className={styles.modal_h5}>Subject</Typography>
                                    <Box className={styles.status_messages_inputfrm}>
                                        <TextField />
                                    </Box>
                                </Box>
                            </Grid>

                            <Grid item lg={12} xs={12}>
                                <Box className={styles.ticket_form_modal}>
                                    <Typography variant='h5' className={styles.modal_h5}>How can we help you?</Typography>
                                    <Box className={`${styles.status_messages_inputfrm} ${styles.textareas}`}>
                                        <TextField multiline />
                                    </Box>
                                </Box>
                            </Grid>

                            <Grid item lg={12} xs={12}>
                                <Box className={styles.ticket_form_modal}>
                                    <Box className={styles.attach_frm_messages}>
                                        <Box className={styles.input_boxfile_attach}>
                                            <Box className={styles.input_boxfile_outer} onClick={() => handleClick()}>
                                                <Typography variant='caption'><i><UploadPin /></i> Attach a file</Typography>
                                            </Box>
                                            <TextField type='file' className={styles.file_uploaders} ref={fileInput} />
                                        </Box>
                                    </Box>
                                </Box>
                            </Grid>

                            <Grid item lg={12} xs={12} className={styles.submit_sec_btms}>
                                <Box className={styles.submit_sec_btns_foot}>
                                    <Button className={styles.cancel_btn_modal} onClick={ticketClose}>Cancel</Button>
                                    <Button className={styles.send_btn_modal} onClick={ticketCreated}>Send <Typography variant='caption'>now</Typography></Button>
                                </Box>
                            </Grid>

                        </Grid>

                    </Box>



                </Box>
            </Dialog>

            {/* For no message modal    
                                            */}
            <Dialog onClose={ticketClose3} open={open3} className={styles.dialog_coupon_modals}>
                <Box className={styles.ticket_support_modal}>
                    <Box className={styles.ticket_support_modal_top}>
                        <Typography variant='caption' className={styles.ticket_coupn_sec}>Create a new support ticket</Typography>

                        <Typography variant='caption' className={styles.ticket_id_sec}><strong>Ticket ID:</strong> #SR5264</Typography>
                        <Button className={styles.cross_icons} onClick={ticketClose3}><CrossIcon /></Button>
                    </Box>


                    <Box className={styles.ticket_support_modal_btms}>
                        <Grid container spacing={2} className={styles.ticket_support_modal_btms_row}>
                            <Grid item lg={4.78} xs={12}>
                                <Box className={styles.ticket_form_modal}>
                                    <Typography variant='h5' className={styles.modal_h5}>Priority</Typography>
                                    <Box className={`${styles.status_messages_inputfrm} ${styles.selectbox}`}>
                                        <Select
                                            onChange={handleChange3}
                                            value={age2}
                                        >
                                            {
                                                TicketSelectItem.map((item, index) => (
                                                    <MenuItem value={index}>{item?.name}</MenuItem>
                                                ))
                                            }

                                        </Select>
                                    </Box>
                                </Box>
                            </Grid>

                            <Grid item lg={12} xs={12}>
                                <Box className={styles.ticket_form_modal}>
                                    <Typography variant='h5' className={styles.modal_h5}>Subject</Typography>
                                    <Box className={styles.status_messages_inputfrm}>
                                        <TextField />
                                    </Box>
                                </Box>
                            </Grid>

                            <Grid item lg={12} xs={12}>
                                <Box className={styles.ticket_form_modal}>
                                    <Typography variant='h5' className={styles.modal_h5}>How can we help you?</Typography>
                                    <Box className={`${styles.status_messages_inputfrm} ${styles.textareas}`}>
                                        <TextField multiline />
                                    </Box>
                                </Box>
                            </Grid>

                            <Grid item lg={12} xs={12}>
                                <Box className={styles.ticket_form_modal}>
                                    <Box className={styles.attach_frm_messages}>
                                        <Box className={styles.input_boxfile_attach}>
                                            <Box className={styles.input_boxfile_outer} onClick={() => handleClick()}>
                                                <Typography variant='caption'><i><UploadPin /></i> Attach a file</Typography>
                                            </Box>
                                            <TextField type='file' className={styles.file_uploaders} ref={fileInput} />
                                        </Box>
                                    </Box>
                                </Box>
                            </Grid>

                            <Grid item lg={12} xs={12} className={styles.submit_sec_btms}>
                                <Box className={styles.submit_sec_btns_foot}>
                                    <Button className={styles.cancel_btn_modal} onClick={ticketClose3}>Cancel</Button>
                                    <Button className={styles.send_btn_modal} onClick={ticketClose3}>Send <Typography variant='caption'>now</Typography></Button>
                                </Box>
                            </Grid>

                        </Grid>

                    </Box>



                </Box>
            </Dialog>
        </>
    );
}

export default QcSupport;